export default __webpack_public_path__ + "static/media/loader.1dec7f54.svg";